import React, { createContext, useEffect, useMemo, useState } from 'react';

export const EarnContext = createContext<{
  offerCategories: Array<string>;
  setOfferCategories: (categories: Array<string>) => void;
}>({
  offerCategories: [],
  setOfferCategories: () => {}
});

export const EarnContextProvider: React.FC = (props) => {
  const { children } = props;

  const [offerCategories, setOfferCategories] = useState<Array<string>>([]);

  return <EarnContext.Provider value={{ offerCategories, setOfferCategories }}>{children}</EarnContext.Provider>;
};
